var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTasks({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14.857,
    height: 16.286,
    viewBox: "0 0 14.857 16.286",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1746",
    "data-name": "Rectangle 1746",
    width: 14.857,
    height: 16.286,
    transform: "translate(-1 -1)",
    fill: "none",
    stroke: "#16161a",
    strokeWidth: 1.6
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3127",
    "data-name": "Group 3127",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3126",
    "data-name": "Group 3126",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8472",
    "data-name": "Path 8472",
    d: "M6.715,9.476a2.274,2.274,0,0,1-1.187-.329L1.158,6.479a1.887,1.887,0,0,1,0-3.283L5.528.529A2.309,2.309,0,0,1,7.9.528L12.272,3.2a1.887,1.887,0,0,1,0,3.283L7.9,9.147A2.274,2.274,0,0,1,6.715,9.476Zm0-7.676a.688.688,0,0,0-.354.094L1.992,4.562a.339.339,0,0,0-.19.276.338.338,0,0,0,.189.275l4.37,2.668a.706.706,0,0,0,.706,0l4.371-2.668a.338.338,0,0,0,.189-.275.339.339,0,0,0-.19-.276L7.067,1.894A.687.687,0,0,0,6.715,1.8Z",
    transform: "translate(-0.286 -0.286)",
    fill: "#16161a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8473",
    "data-name": "Path 8473",
    d: "M6.714,14.626A2.286,2.286,0,0,1,5.527,14.3l-3.82-2.329-.551-.34A1.912,1.912,0,0,1,.2,9.941a.8.8,0,1,1,1.6.043.329.329,0,0,0,.188.278l.006,0,.55.339,3.816,2.326a.72.72,0,0,0,.711,0L10.888,10.6l.548-.337.006,0a.332.332,0,0,0,.187-.273.8.8,0,0,1,1.6,0,1.921,1.921,0,0,1-.956,1.639l-.549.338L7.9,14.3A2.289,2.289,0,0,1,6.714,14.626Z",
    transform: "translate(-0.286 -2.846)",
    fill: "#16161a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8474",
    "data-name": "Path 8474",
    d: "M6.714,18.255a2.288,2.288,0,0,1-1.186-.328l-4.371-2.67A1.922,1.922,0,0,1,.2,13.57a.8.8,0,0,1,1.6.04.337.337,0,0,0,.191.283L6.36,16.561a.724.724,0,0,0,.712,0l4.366-2.667a.347.347,0,0,0,.191-.268.8.8,0,1,1,1.6.066,1.921,1.921,0,0,1-.955,1.568L7.9,17.926A2.3,2.3,0,0,1,6.714,18.255Z",
    transform: "translate(-0.286 -3.883)",
    fill: "#16161a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasks);
export default __webpack_public_path__ + "static/media/tasks.eed6527e79d976f7c5441c9be44d1ae2.svg";
export { ForwardRef as ReactComponent };